import { useSelector } from 'react-redux';
import {
    Drawer as ChakraDrawer,
    DrawerOverlay,
    DrawerContent,
} from '@chakra-ui/react';

const Drawer = ({ isOpen, onClose, children, onCloseAction }) => {
    const { darkMode } = useSelector((state) => state.settings);
    const extraActions = () => {
        onClose();
        if (typeof onCloseAction === 'function') {
            onCloseAction();
        }
    };
    return (
        <ChakraDrawer
            isOpen={isOpen}
            placement="right"
            onClose={extraActions}
            size="xl"
            closeOnOverlayClick={true}>
            <DrawerOverlay />
            <DrawerContent
                overflowY="auto"
                bg={darkMode ? 'var(--chakra-colors-dark-bgDark)' : '#F5F5F5'}
                padding="35px"
                position="relative">
                {children}
            </DrawerContent>
        </ChakraDrawer>
    );
};

export default Drawer;
